import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

interface IParams {
  appId: string
}

export const getAppUsersAppsSearchCrud = ({ appId }: IParams) => {
  const crud = CrudStore.get(CrudStoreItem.AppUsersAppsSearch, 'Managers')
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'Id',
        operator: Operator.CONTAINS,
        value: '@hp.com',
      },
      {
        field: 'AppId',
        operator: Operator.EQUAL,
        value: appId,
      },
    ],
  })

  return crud
}
